import { useMutation } from 'react-query';
import { replaceStolenFormaCard } from 'apis/formaCards';
import { AxiosError } from 'axios';

const useMutationFormaCardStolen = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (e: AxiosError) => void;
}) => {
  const {
    mutate,
    data,
    isSuccess: is_success,
    isError: is_error,
    isLoading: is_loading,
  } = useMutation(
    ({
      shipping_address,
      card_id,
    }: {
      shipping_address: {
        city: string;
        street: string;
        street2?: string;
        state: string;
        postalCode: string;
        country: string;
      };
      card_id?: string;
    }) =>
      replaceStolenFormaCard({
        shipping_address,
        card_id,
      }),
    {
      onSuccess,
      onError,
    }
  );

  return {
    data,
    mutate,
    is_loading,
    is_success,
    is_error,
  };
};

export default useMutationFormaCardStolen;
